import { genKey } from "draft-js";

const tableStructure = {
  makeCell: (params) => {
    return {
      key: genKey(),
      ...params,
    };
  },

  cellDefaults: () => {
    return {
      borderTop: false,
      borderRight: false,
      borderLeft: false,
      borderBottom: false,
      padding: 2,
      backgroundColor: "#FFFFFF",
      verticalAlign: "top",
    };
  },

  create: (rows, cols) => {
    let table = [];
    const cellDefaults = tableStructure.cellDefaults();
    const defaultWidth = 10;
    for (let row = 0; row < rows; row++) {
      let line = [];
      for (let col = 0; col < cols; col++) {
        line.push(
          tableStructure.makeCell({
            width: defaultWidth,
            text: ``,
            self: col === 0 && row === 0,
            ...cellDefaults,
          })
        );
      }
      table.push(line);
    }
    return table;
  },

  colAdd: (table, currentCol, direction) => {
    let resultTable = [];
    if (table && Array.isArray(table)) {
      table.forEach((row, rowIndex) => {
        let line = [];
        row.forEach((cell, colIndex) => {
          if (direction === "right") {
            line.push({
              ...cell,
              self: rowIndex === 0 && colIndex === 0,
            });
            if (currentCol === colIndex) {
              line.push({
                ...cell,
                key: genKey(),
                text: "",
                self: false,
                table: null,
              });
            }
          }
          if (direction === "left") {
            if (currentCol === colIndex) {
              line.push({
                ...cell,
                key: genKey(),
                text: "",
                self: false,
                table: null,
              });
            }
            line.push({
              ...cell,
              self: rowIndex === 0 && colIndex === 0,
            });
          }
        });
        resultTable.push(line);
      });
    }
    return resultTable;
  },

  rowAdd: (table, currentRow, direction) => {
    let resultTable = [];
    if (table && Array.isArray(table)) {
      table.forEach((row, rowIndex) => {
        if (direction === "down") {
          resultTable.push(tableStructure.duplicateRow(row, rowIndex));
          if (rowIndex === currentRow) {
            resultTable.push(
              tableStructure.duplicateRow(row, rowIndex + 1, true)
            );
          }
        }
        if (direction === "up") {
          if (rowIndex === currentRow && rowIndex) {
            resultTable.push(tableStructure.duplicateRow(row, rowIndex, true));
            resultTable.push(tableStructure.duplicateRow(row, rowIndex + 1));
          } else {
            resultTable.push(tableStructure.duplicateRow(row, rowIndex));
          }
        }
      });
    }
    return resultTable;
  },

  duplicateRow: (row, rowIndex, insertNewCells = false) => {
    let resultRow = [];
    if (row && Array.isArray(row)) {
      row.forEach((cell, colIdx) => {
        resultRow.push({
          ...cell,
          key: insertNewCells ? genKey() : cell.key,
          text: insertNewCells ? "" : cell.text,
          self: rowIndex === 0 && colIdx === 0,
        });
      });
    }
    return resultRow;
  },

  cellLocate: (table, key) => {
    let result = {};
    if (table && Array.isArray(table)) {
      table.forEach((row, rowIdx) => {
        row.forEach((col, colIdx) => {
          if (key === col.key) {
            result = {
              row: rowIdx,
              col: colIdx,
            };
          }
        });
      });
    }
    return result;
  },

  getAllKeys: (table) => {
    let result = [];
    if (table && Array.isArray(table)) {
      table.forEach((row, rowIdx) => {
        row.forEach((col, colIdx) => {
          result.push(col.key);
        });
      });
    }
    return result;
  },

  getDiffKeys: (table1, table2) => {
    let keys1 = tableStructure.getAllKeys(table1);
    let keys2 = tableStructure.getAllKeys(table2);
    let diff = keys2.filter((key) => !keys1.includes(key));
    return diff;
  },
};
export default tableStructure;
